import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import _ from "lodash";
import MutationBuildingToTimeslot from 'graphql/mutations/MutationBuildingToTimeslot'
import MutationFloorToTimeslot from 'graphql/mutations/MutationFloorToTimeslot'
import MutationRoomToTimeslot from 'graphql/mutations/MutationRoomToTimeslot'
import MutationTableToTimeslot from 'graphql/mutations/MutationTableToTimeslot'

export const MutateToTimeslotTables = {
	BUILDING: 'building',
	FLOOR: 'floor',
	ROOM: 'room',
	TABLE: 'table',
}

const MutateToTimeslot = {
	
	tableToGuid: ( table ) => {
		switch( table ) {
			case MutateToTimeslotTables.BUILDING:
				return 'building_guid';
			
			case MutateToTimeslotTables.FLOOR:
				return 'floor_guid';
			
			case MutateToTimeslotTables.ROOM:
				return 'room_guid';
			
			case MutateToTimeslotTables.TABLE:
				return 'table_guid';
			
			default:
				return null;
		}
	},
	
	mutate: ( table, guid, timeslots, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const builder = new GraphqlBuilder({
			[ graphqlOptions.processVariables ]: false
		});
		
		let mutation = null;
		let mutationKey = MutateToTimeslot.tableToGuid( table );
		switch( table ) {
			case MutateToTimeslotTables.BUILDING:
				mutation = MutationBuildingToTimeslot;
				break;
				
			case MutateToTimeslotTables.FLOOR:
				mutation = MutationFloorToTimeslot;
				break;
				
			case MutateToTimeslotTables.ROOM:
				mutation = MutationRoomToTimeslot;
				break;
				
			case MutateToTimeslotTables.TABLE:
				mutation = MutationTableToTimeslot;
				break;
		}
		
		// No mutation? Error..
		if( mutation === null ) {
			MutateToTimeslot.onError( {}, callbackError );
			return;
		}
		
		builder.addQuery( `mutation_${table}_to_timeslot`, mutation, {
			[ mutationKey ]: guid,
			timeslot_guid: _.map( timeslots, t => {
				return t.guid;
			} ),
		} );
		
		builder.setOnStart( callbackStart )
		builder.setOnSuccess( ( result ) => {
			MutateToTimeslot.onSuccess( result, callbackSuccess );
		});
		builder.setOnError( (result) => {
			MutateToTimeslot.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}
		
		MutateToTimeslot.onSuccess( {}, callbackSuccess );
	},
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	onSuccess: ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	},
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	onError: ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	},
}

export default MutateToTimeslot
